import { render, staticRenderFns } from "./route.vue?vue&type=template&id=4d28288c&scoped=true&"
import script from "./route.vue?vue&type=script&lang=ts&"
export * from "./route.vue?vue&type=script&lang=ts&"
import style0 from "./route.vue?vue&type=style&index=0&id=4d28288c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28288c",
  null
  
)

export default component.exports